
    import { computed, defineComponent, onBeforeMount, ref } from 'vue'
    import { DateTime } from 'luxon'

    import { broadcastEvent } from '@/common/json-ld/media'
    import { Schedule } from '@/common/models/data/dashboard/schedule/schedule'

    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { useScheduleStore } from '@/app/stores/schedule'

    import { useHeadful } from '@/common/composables/libs/headful'
    import { useI18n } from 'vue-i18n-composable'

    export default defineComponent({
        setup () {
            const headful = useHeadful()
            const i18n = useI18n()
            const scheduleStore = useScheduleStore()

            // Need to "- 1" here, because tab needs to be in range 0 to 6 when
            // ISO day number is from 1 to 7 where 7 is the sunday.
            const openedTab = ref(DateTime.local().weekday - 1)

            const days = computed(() => scheduleStore.dayKeys)
            const schedule = computed(() => scheduleStore.schedule)

            const jsonLd = (event: Schedule) => broadcastEvent(event)

            const nl2br = (str: string): string => {
                // based on https://locutus.io/php/strings/nl2br/
                return str.replace(/(\r\n|\n\r|\r|\n)/g, '<br>$1')
            }

            onBeforeMount(async (): Promise<void> => {
                useBreadcrumbsStore().reset()
                headful({
                    title: `${i18n.t('nav.schedule.what-we-play')} | ${i18n.t('meta.title')}`
                })

                await scheduleStore.load()
            })

            return {
                days,
                openedTab,
                schedule,
                jsonLd,
                nl2br
            }
        }
    })
